import {Injectable} from '@angular/core';

/*
 * Menu interface
 */
export interface Menu {
  state: string;
  name?: string;
  type?: string;
  icon?: string;
  children?: ChildrenItems[];
}

/*
 * Children menu interface
 */
export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

const HEADERMENUITEMS = [
  {
    state: 'monitoring',
    name: 'Monitoring',
    type: 'sub',
    icon: '',
    children: [
      {
        state: 'monitoring',
        name: 'River monitoring',
        type: 'subchild',
        children: [
          {
            state: '/rainfall-monitoring',
            name: 'Cumulative Rainfall Monitoring',
            type: 'link'
          },
          {
            state: 'river-monitoring-telemetry',
            name: 'Hydromet Telemetry Network',
            type: 'link'
          },
          {
            state: 'groundwater',
            name: 'Groundwater',
            type: 'link'
          },
        ]
      },
      {
        state: 'flood-forecasting',
        name: 'Flood monitoring & forecasting',
        type: 'link'
      },
      {
        state: 'drought',
        name: 'Drought monitoring',
        type: 'subchild',
        children: [
          {
            state: 'drought-archive',
            name: 'Drought archive',
            type: 'link'
          },
          {
            state: 'http://droughtforecast.mrcmekong.org/',
            name: 'Drought monitoring',
            type: 'extlink'
          },
        ]
      },

      {
        state: '/map-service/rsat',
        name: 'Reservoir Monitoring',
        type: 'link'
      },
      {
        state: 'dsmp',
        name: 'Discharge & sediment monitoring',
        type: 'subchild',
        children: [
          {
            state: 'dsmp-description',
            name: 'Description',
            type: 'link'
          },
          {
            state: 'dsmp-geomorphology-survey',
            name: 'Geomorphology survey',
            type: 'link'
          },
          {
            state: 'dsmp-laboratory',
            name: 'Laboratory',
            type: 'link'
          },
          {
            state: 'dsmp-data-collection',
            name: 'Data collection',
            type: 'link'
          },
          {
            state: 'dsmp-documents',
            name: 'Documents',
            type: 'link'
          },
        ]
      },
      {
        state: 'biomonitoring',
        name: 'Environmental Health Monitoring',
        type: 'link'
      },
      {
        state: 'water-quality',
        name: 'Water quality monitoring',
        type: 'link'
      },
      {
        state: 'fisheries',
        name: 'Fisheries monitoring',
        type: 'link'
      },
    ]
  },

  {
    state: 'time-series',
    name: 'Time-Series',
    type: 'sub',
    icon: '',
    children: [
      {
        state: 'dashboard',
        name: 'Time-series dashboard',
        type: 'link'
      },
      {
        state: '',
        name: 'Time-series inventory',
        type: 'link'
      },
      {
        state: 'time-series',
        name: 'Hydromet time-series',
        type: 'subchild',
        children: [
          {
            state: 'water-level',
            name: 'Water Level',
            type: 'link'
          },
          {
            state: 'rainfall',
            name: 'Rainfall',
            type: 'link'
          },
          {
            state: 'discharge',
            name: 'Discharge',
            type: 'link'
          },
          {
            state: 'sediment-concentration',
            name: 'Sediment Concentration',
            type: 'link'
          },
          {
            state: 'sediment-flux',
            name: 'Sediment Flux',
            type: 'link'
          },
        ]
      },
      {
        state: 'time-series',
        name: 'Fisheries time-series',
        type: 'subchild',
        children: [
          {
            state: 'fish-count',
            name: 'Fish Count',
            type: 'link'
          },
          {
            state: 'catch-per-unit-effort',
            name: 'Catch Per Unit Effort',
            type: 'link'
          },
          {
            state: 'catch-per-unit-effort-100sqm',
            name: 'Catch Per Unit Effort 100sqm',
            type: 'link'
          },
          {
            state: 'species-count',
            name: 'Species Count',
            type: 'link'
          },
          {
            state: 'total-weight',
            name: 'Total Weight',
            type: 'link'
          }
        ]
      },
      {
        state: 'time-series',
        name: 'Ecological Biomonitoring time-series',
        type: 'subchild',
        children: [
          {
            state: 'bentho-abundance',
            name: 'Bentho Abundance',
            type: 'link'
          },
          {
            state: 'bentho-richness',
            name: 'Bentho Richness',
            type: 'link'
          },
          {
            state: 'bentho-atspt',
            name: 'Bentho ATSPT',
            type: 'link'
          },

          {
            state: 'diatom-abundance',
            name: 'Diatom Abundance',
            type: 'link'
          },
          {
            state: 'diatom-richness',
            name: 'Diatom Richness',
            type: 'link'
          },
          {
            state: 'diatom-atspt',
            name: 'Diatom ATSPT',
            type: 'link'
          },

          {
            state: 'littoral-abundance',
            name: 'Littoral Abundance',
            type: 'link'
          },
          {
            state: 'littoral-richness',
            name: 'Littoral Richness',
            type: 'link'
          },
          {
            state: 'littoral-atspt',
            name: 'Littoral ATSPT',
            type: 'link'
          },

          {
            state: 'zooplankton-abundance',
            name: 'Zooplankton Abundance',
            type: 'link'
          },
          {
            state: 'zooplankton-richness',
            name: 'Zooplankton Richness',
            type: 'link'
          },
          {
            state: 'zooplankton-atspt',
            name: 'Zooplankton ATSPT',
            type: 'link'
          },
        ]
      },
      {
        state: 'time-series',
        name: 'Water quality time-series',
        type: 'subchild',
        children: [
          {
            state: 'ammonium',
            name: 'Ammonium',
            type: 'link'
          },
          {
            state: 'chemical-oxygen-demand',
            name: 'Chemical Oxygen Demand',
            type: 'link'
          },
          {
            state: 'conductivity',
            name: 'Conductivity',
            type: 'link'
          },
          {
            state: 'dissolved-oxygen',
            name: 'Dissolved Oxygen',
            type: 'link'
          },
          {
            state: 'nitrite-nitrate',
            name: 'Nitrite-Nitrate',
            type: 'link'
          },
          {
            state: 'ph',
            name: 'pH',
            type: 'link'
          },
          {
            state: 'total-phosphorous',
            name: 'Total Phosphorous',
            type: 'link'
          },
          {
            state: 'total-nitrogen',
            name: 'Total Nitrogen',
            type: 'link'
          },
          {
            state: 'total-suspended-solids',
            name: 'Total Suspended Solids',
            type: 'link'
          },
          {
            state: 'water-temperature',
            name: 'Water Temperature',
            type: 'link'
          },
        ]
      },
      {
        state: 'stations',
        name: 'Time-series station map',
        type: 'link'
      },
      {
        state: 'request',
        name: 'Time-series data request',
        type: 'link'
      },
    ]
  },

  {
    state: 'map-service',
    name: 'Map Service',
    type: 'sub',
    icon: '',
    children: [
      {
        state: 'lmb-atlas-inventory',
        name: 'LMB Atlas Inventory',
        type: 'link'
      },
      {
        state: '/map-service',
        name: 'Interactive Map Service',
        type: 'link'
      },
    ]
  },
  {
    state: 'topic',
    name: 'Information',
    type: 'sub',
    icon: '',
    children: [
      // {
      //     state: 'climate-change',
      //     name: 'Climate change & adaptation',
      //     type: 'link'
      // },
      {
        state: 'info',
        name: '2013-2015 indexes mapping',
        type: 'subchild',
        icon: '',
        children: [
          {
            state: 'water-extent',
            name: 'Water extent mapping',
            type: 'link'
          },
          // {
          //   state: 'gsmap',
          //   name: 'Global Satellite Mapping of Precipitation',
          //   type: 'link'
          // },
          // {
          //   state: 'kbdi',
          //   name: ' Keetch–Byram Drought Index',
          //   type: 'link'
          // },
          // {
          //   state: 'ndvi',
          //   name: ' Normalize Difference Vegetation Index',
          //   type: 'link'
          // },
          // {
          //   state: 'vci',
          //   name: ' Vegetation Crop Index',
          //   type: 'link'
          // },
        ]
      },
      // {
      //   state: 'environment',
      //   name: 'Environment',
      //   type: 'link'
      // },
      // {
      //   state: 'fisheries',
      //   name: 'Fisheries',
      //   type: 'link'
      // },
      // {
      //   state: 'flood-and-drought',
      //   name: 'Flood & Drought',
      //   type: 'link'
      // },
      {
        state: 'land-cover',
        name: 'Land cover information',
        type: 'subchild',
        icon: '',
        children: [
          {
            state: 'land-cover-description',
            name: 'Description',
            type: 'link'
          },
          {
            state: 'land-cover-data-collection',
            name: 'Field data collection',
            type: 'link'
          },
          {
            state: 'land-cover-types',
            name: 'Land cover types',
            type: 'link'
          },
          {
            state: 'land-cover-documents',
            name: 'Technical report',
            type: 'link'
          },
        ]
      },
      {
        state: 'hydropower',
        name: 'Hydropower',
        type: 'subchild',
        icon: '',
        children: [
          {
            state: '/hydropower/map',
            name: 'Hydropower Database',
            type: 'link'
          },
          {
            state: 'hydropower-documents',
            name: 'Legal documents on hydropower development',
            type: 'link'
          },
        ]
      },
      {
        state: '/sedb',
        name: 'Social and Economic database',
        type: 'link',
      },
      // {
      //   state: 'tourism',
      //   name: 'Tourism',
      //   type: 'link'
      // },
    ]
  },

  {
    state: 'procedure',
    name: 'Procedures',
    type: 'sub',
    icon: '',
    children: [
      {
        state: 'procedure',
        name: '1995 Mekong Agreements',
        type: 'subchild',
        icon: '',
        children: [
          {
            state: 'https://www.mrcmekong.org/history/',
            name: 'History',
            type: 'extlink'
          },
        ]
      },
      {
        state: 'procedure',
        name: 'PDIES',
        type: 'subchild',
        icon: '',
        children: [
          {
            state: 'pdies-overview',
            name: 'Overview',
            type: 'link'
          },
          {
            state: 'pdies-list-of-primary-custodians',
            name: 'Primary custodians',
            type: 'link'
          },
        ]
      },
      {
        state: 'procedure',
        name: 'PNPCA',
        type: 'subchild',
        icon: '',
        children: [
          {
            state: 'pnpca-overview',
            name: 'Overview',
            type: 'link'
          },
          {
            state: '/pnpca/map',
            name: 'PNPCA Database',
            type: 'link'
          },
          {
            state: 'pnpca-documents',
            name: 'Documents & Videos',
            type: 'link'
          },
          {
            state: 'https://web.archive.org/web/20160314121209/http://www.mrcmekong.org/news-and-events/consultations/don-sahong-hydropower-project/frequently-asked-questions-on-don-sahong-project-s-prior-consultation/',
            name: 'FAQs on PNPCA',
            type: 'extlink'
          },
          {
            state: 'https://www.mrcmekong.org/news_and_events/xayaburi-hydropower-project/',
            name: 'Prior consultation on Xayaburi Project',
            type: 'extlink'
          },
          {
            state: 'https://www.mrcmekong.org/news_and_events/don-sahong-hydropower-project/',
            name: 'Prior consultation on Don Sahong',
            type: 'extlink'
          },
          {
            state: 'https://www.mrcmekong.org/news_and_events/pak-beng-hydropower-project/',
            name: 'Prior consultation on Pak Beng',
            type: 'extlink'
          },
          {
            state: 'https://www.mrcmekong.org/news_and_events/pak-lay-hydropower-project/',
            name: 'Prior consultation on Pak Lay Project',
            type: 'extlink'
          },
          {
            state: 'https://www.mrcmekong.org/news_and_events/luang-prabang-hydropower-project/',
            name: 'Prior consultation on Luang Prabang Project',
            type: 'extlink'
          },
          {
            state: 'https://www.mrcmekong.org/news_and_events/sanakham-hydropower-project/',
            name: 'Prior consultation on Sanakham Project',
            type: 'extlink'
          },

        ]
      },
      {
        state: 'procedure',
        name: 'PWUM',
        type: 'subchild',
        icon: '',
        children: [
          {
            state: 'pwum-overview',
            name: 'Overview',
            type: 'link'
          },
          {
            state: 'pwum-documents',
            name: 'Water Use monitoring',
            type: 'link'
          },
        ]
      },
      {
        state: 'https://pmfm.mrcmekong.org/',
        name: 'PMFM',
        type: 'extlink'
      },
      {
        state: 'procedure',
        name: 'PWQ',
        type: 'subchild',
        icon: '',
        children: [
          {
            state: 'pwq-overview',
            name: 'Overview',
            type: 'link'
          },
          {
            state: 'pwq-documents',
            name: 'PWQ Documents',
            type: 'link'
          },
          {
            state: 'pwq-faq',
            name: 'PWQ FAQs',
            type: 'link'
          },
          {
            state: '/monitoring/water-quality',
            name: 'Water Quality monitoring',
            type: 'link'
          },
        ]
      }
    ]
  },

  {
    state: 'toolbox',
    name: 'Toolbox',
    type: 'sub',
    icon: '',
    children: [

      {
        state: 'mrctoolbox',
        name: 'MRC DSF / Toolbox',
        type: 'link'
      },
      {
        state: 'model',
        name: 'Toolbox model',
        type: 'link'
      },
      {
        state: 'application',
        name: 'Toolbox application',
        type: 'link'
      }
    ]
  },

  // {
  //     state: 'data-catalogue',
  //     name: 'Data Catalogue',
  //     type: 'link',
  //     icon: '',
  // }
];

const FooterOneItems = [
  {
    state: '',
    name: 'Data Portal',
    type: 'sub',
    icon: '',
    children: [
      {
        state: 'home',
        name: 'Home',
        type: 'link'
      },
      {
        state: 'glossary',
        name: 'Glossary',
        type: 'link'
      },
      {
        state: 'account/register',
        name: 'Register',
        type: 'link'
      },
      {
        state: 'contact',
        name: 'Contact',
        type: 'link'
      },
    ]
  },
  {
    state: '',
    name: 'Data License & Terms',
    type: 'sub',
    icon: '',
    children: [
      {
        state: 'about/terms-of-service',
        name: 'Terms of Service',
        type: 'link'
      },
      {
        state: 'about/privacy-policy',
        name: 'Privacy Policy',
        type: 'link'
      },
      {
        state: 'about/data-fees',
        name: 'Data Fees',
        type: 'link'
      },
      {
        state: 'about/account-types',
        name: 'Account Types',
        type: 'link'
      },
      {
        state: 'about/disclaimer',
        name: 'Disclaimer',
        type: 'link'
      },

    ]
  }
];

@Injectable()
export class MenuItems {

  /*
   * Get all header menu
   */
  getMainMenu(): Menu[] {
    return HEADERMENUITEMS;
  }

  /*
   * Get all footer menu
   */
  getFooterOneMenu(): Menu[] {
    return FooterOneItems;
  }
}
